import React, { useEffect, useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { getAgreementsRequest } from "@/services";
import { useParams } from "react-router-dom";

export default function AgreementListModal({ show, onHide, loanId }) {
  const { applicationId } = useParams();
  const [agreements, setAgreements] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) loadData();
  }, [show]);

  const loadData = async () => {
    setLoading(true);
    try {
      const resp = await getAgreementsRequest({ loan_id: applicationId });
      if (resp?.status) setAgreements(resp.results || []);
    } finally {
      setLoading(false);
    }
  };

  // Group by agreement type
  const grouped = agreements.reduce((acc, item) => {
    const key = item.agreement_type_value || item.agreement_type;
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});

  const getFileLabel = (doc, idx) => {
    const f1 = doc.signed_document?.file_name;
    const f2 = doc.signed_document?.document_url?.split("/").pop();
    return f1 || f2 || `Document ${idx + 1}`;
  };

  const getGuarantor = (doc) =>
    doc.metadata?.personal_guarantor || doc.metadata?.remarks || null;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Agreements</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <div className="d-flex justify-content-center py-4">
            <Spinner animation="border" />
          </div>
        ) : (
          <div className="agreement-groups">

            <p className="text-muted" style={{ fontSize: "14px" }}>
              Please review the required agreements. These documents formalize lending terms and are required for compliance.
            </p>

            {Object.entries(grouped).map(([group, docs]) => (
              <div key={group} style={{ marginBottom: "32px" }}>
                <h5 style={{ fontWeight: 600, marginBottom: "12px" }}>{group}</h5>

                <div style={{
                  border: "1px solid #E5E7EB",
                  borderRadius: "8px",
                  background: "#FFFFFF"
                }}>
                  {docs.map((doc, idx) => {
                    const name = doc.signed_document?.file_name || `Document ${idx + 1}`;
                    const guarantor = doc.metadata?.personal_guarantor || null;

                    return (
                      <div key={doc.id} style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "14px 18px",
                        borderBottom: idx !== docs.length - 1 ? "1px solid #F1F3F4" : "none"
                      }}>
                        <div style={{ width: "70%" }}>
                          <div style={{
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "#111",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "100%"
                          }}>
                            {name}
                          </div>

                          {guarantor && (
                            <div style={{ fontSize: "13px", color: "#6B7280", marginTop: "3px" }}>
                              Personal Guarantor: <strong>{guarantor}</strong>
                            </div>
                          )}
                        </div>

                        <div style={{ width: "30%", textAlign: "right" }}>
                          <Button
                            size="sm"
                            variant="outline-primary"
                            onClick={() => window.open(doc.signed_document_url, "_blank")}
                            disabled={!doc.signed_document_url}
                          >
                            View Signed Copy
                          </Button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}

            {!agreements.length && (
              <p className="text-center text-muted py-3">No agreements available.</p>
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}